import React from "react"
import useWindowDimensions from "@hooks/useWindowDimensions"
import BackToBlogButton from "../BackToBlogButton";
import {
  ArticleAuthor,
  ArticleSummary,
} from "./components"
import { StyledArticleTitle } from "./styled"

const ArticleInformation = ({ title, author, categories, date, read_time }) => {
  const { isTablet, isMobile } = useWindowDimensions()
  return (
    <>
      {(isTablet || isMobile) && <BackToBlogButton />}
      <ArticleSummary 
        categories={categories} 
        date={date} 
        read_time={read_time} 
      />
      <StyledArticleTitle>{title}</StyledArticleTitle>
      <ArticleAuthor {...author} />
    </>
  )
}

export default ArticleInformation
